import { useQuery } from 'react-query'
import request from '../request'

export const useGetAmazonAdsAccounts = () => {
  return useQuery(['admin', 'amazon_ads', 'dealerships'], ({ signal }) =>
    request<{
      data: Array<{
        label: string
        value: string
      }>
    }>({
      url: `/admin/dsp/amazon/accounts`,
      method: 'GET',
      signal,
    }).then((res: any) => res.data),
  )
}
